
export const TableTd = ({children, ...rest}) => {
    return(
        <td {...rest}>
            {children}
        </td>
    )
}